export { Tabs } from '@mantine/core'